import { avatarIdentity } from '@/lib/identityAvatar';
import { useState } from 'react';

/** Real photos always win. Initials render immediately, including failed photos. */
export function IdentityAvatar({ name, id, src, className = '', size = 'sm' }: {
  name: string;
  id: string;
  src?: string | null;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const { tone, initials } = avatarIdentity(name, id);
  return <span className={`studio-avatar studio-avatar-${size} ${className}`} data-tone={tone} aria-hidden="true">
    <span>{initials || '?'}</span>
    {src && failedSrc !== src && <img src={src} alt="" onError={() => setFailedSrc(src)} />}
  </span>;
}
